import React from 'react';
import { Alert } from 'reactstrap';
import { MessageValue, FormattedMessage } from 'react-intl';


export interface EhpcMessageValues {
  [key: string]: MessageValue | JSX.Element;
}

export interface EhpcMessage {
  id?: string;
  message?: string;
  messageId?: string;
  messageValues?: EhpcMessageValues;
  color: string;
}

export interface MessagesProps {
  messages: EhpcMessage[];
  setMessage?: Function;
  removeMessage?: Function;
}

export const Messages: React.FC<MessagesProps> = ({ messages = [], setMessage = () => {}, removeMessage = () => {}}): JSX.Element | null => {


  return (
    <React.Fragment>
      {messages.map(m => {
        return (
          <Alert key={m.id} color={m.color} isOpen={true} toggle={() => removeMessage(m)}>
            {m.message && 
            <React.Fragment>
              {m.message}
            </React.Fragment>
            }
            {m.messageId && 
              <FormattedMessage id={m.messageId} values={m.messageValues} />
            }
          </Alert>
        );
      })}
    </React.Fragment>
  );

}
